import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Text, TextPreset, Color, ShadeColor } from '@pegasus/ui-components/components/text';
import Translate from '@client/components/shared/translation/Translate';
import styles from './discount.scss';

export function Discount({ campaign, discount }) {
    return (
        <div styleName="wrapper">
            {campaign.options && campaign.options.specialBadge ? (
                <Text preset={TextPreset.M_BOLD} color={Color.dark} styleName="special-discount">
                    <Translate message="campaigns.campaignSpecial" />
                </Text>
            ) : (
                <span styleName="regular-discount">
                    <Text preset={TextPreset.XXS} color={ShadeColor.dark60} styleName="regular-discount-text">
                        <Translate message="campaigns.upTo" />
                    </Text>
                    <Text preset={TextPreset.M_BOLD} color={Color.dark} styleName="max-discount">-{discount}</Text>
                </span>
            )}
        </div>
    );
}

Discount.propTypes = {
    campaign: PropTypes.object.isRequired,
    discount: PropTypes.string.isRequired
};

export default CSSModules(Discount, styles, { allowMultiple: true });
